/**
 * ./exercise5/Exercise5.js
 * 
 * This module is similar with previous exercises. 
 * 
 */

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; // useNavigate instead of useHistory
import "../exercise2/Exercise2.css";
import Curtain from "../components/Curtain"; // Import the reusable Curtain component
import SinglewordIcon from "./icons/exercise5icon.svg"; // Import the person icon
import { API_BASE_URL } from "../config";

const Exercise5 = () => {
  const [isCurtainActive, setIsCurtainActive] = useState(true);
  const [isExiting, setIsExiting] = useState(false);
  const navigate = useNavigate(); // Create a navigate function for navigation
  const [userData, setUserData] = useState(null); // We added this

  // We added this
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/user/me`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
        });
        const data = await response.json();
        setUserData(data);
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };
    fetchUserData();
  }, []);

  useEffect(() => {
    // Timer for curtain
    const curtainTimer = setTimeout(() => {
      setIsCurtainActive(false);
    }, 2000);

    // // Timer for auto navigation
    // const navigationTimer = setTimeout(() => {
    //   setIsExiting(true);
    //   setTimeout(() => {
    //     navigate('/exercise5intro');
    //   }, 0);
    // }, 3000);

    // Cleanup both timers
    return () => {
      clearTimeout(curtainTimer);
    };
  }, [navigate]);

  return (
    <div className={`exercise2-page ${isExiting ? "fade-out" : ""}`}>
      {/* Display the curtain and set it to "disappear" */}
      {isCurtainActive && <Curtain disappear={true} duration={2000} />}

      {/* Text content */}
      <div className="exercise2-header">
        <h1>Exercise 5: Comprehension</h1>
      </div>

      {/* Blue bottom area */}
      <div className="exercise2-bottom">
        <img
          className="exercise2-icon"
          src={SinglewordIcon}
          alt="SinglewordIcon"
        />
        <button
          className="start-exercise"
          onClick={() => {
            if (userData.exercisesUnlocked[4] >= 1) {
              navigate("/exercise5intro");
            } else {
              navigate("/Warmupwelcome", { state: { exerciseNumber: 5} });
            }
            setIsExiting(true);
          }}
        >
          <b>START</b>
        </button>
      </div>
    </div>
  );
};

export default Exercise5;
